"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var hs_web_style_guide_1 = require("@headspace/hs-web-style-guide");

var ProgressBar_1 = require("./ProgressBar");

var stepProgressStyle = hs_web_style_guide_1.css({
  padding: '0',
  margin: '0',
  listStyle: 'none',
  display: 'flex'
});

function StepProgress(props) {
  var steps = props.steps,
      barColor = props.barColor,
      currentStep = props.currentStep;
  return React.createElement("ul", __assign({
    className: "step-progress"
  }, stepProgressStyle), Array(steps).fill('').map(function (e, i) {
    return React.createElement(ProgressBar_1.ProgressBar, {
      barColor: barColor,
      selected: currentStep > i,
      key: i
    });
  }));
}

exports.StepProgress = StepProgress;